import React from "react";
import ButtonLink from "./ButtonLink";
import imageUrlBuilder from "@sanity/image-url";
import {
  ButtonContainer,
  DescContainer,
  Description,
  Glass,
  Image,
  ImgContainer,
  ProjectContainer,
  Title,
} from "./styles";
import { client } from "../client";

const builder = imageUrlBuilder(client);

function urlFor(source) {
  return builder.image(source);
}
function Project({ project }) {
  return (
    <ProjectContainer borderColor={project.border_color}>
      <Glass></Glass>
      <ImgContainer>
        <Image src={urlFor(project.project_image)} />
      </ImgContainer>
      <DescContainer>
        <Title>{project.title}</Title>
        <Description>{project.project_desc[0]?.children[0]?.text}</Description>
        <ButtonContainer>
          <ButtonLink text={"chrome"} link={project.hosted_link} />
          <ButtonLink text={"github"} link={project.github_link} />
        </ButtonContainer>
      </DescContainer>
    </ProjectContainer>
  );
}

export default Project;
